import { render, staticRenderFns } from "./VipTipDialog.vue?vue&type=template&id=b8a5f35e&scoped=true&"
import script from "./VipTipDialog.vue?vue&type=script&lang=js&"
export * from "./VipTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./VipTipDialog.vue?vue&type=style&index=0&id=b8a5f35e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5f35e",
  null
  
)

export default component.exports